<template lang="pug">
div
  h2 {{ title }}
  section(v-if='errored')
    p
      | Lo sentimos, no es posible obtener la informaci&oacute;n en este momento, por
      | favor intente nuevamente más tarde
  section(v-else='')
    div.mb-2(v-if="loading") Cargando...
      b-spinner.ml-2(label="Cargando..." small)
    b-card-group#operations(columns='' v-if='!loading')
      px-card#resume-card(v-for='operation in limitedOperations'
              :key='operation.id'
              :id='operation._id'
              :saleId='operation.saleId !== undefined'
              :title="operation.clientId ? operation.clientId.firstName : ''"
              :fullName="operation.clientId ? (operation.clientId.firstName + ' ' + operation.clientId.lastName): ''"
              :cardHeader="operation.passengerGroup.length"
              :cardFooter="operation.total + ' ' + operation.currency"
              :cardContent="operation.routeGroup[0] ? { datetime: operation.routeGroup[0].datetime } : {}"
            )
    b-button.mr-sm-2(v-if="!loading" type='submit' variant='primary' @click="limit += increment") Cargar más
      //b-card(v-for='operation in operations' :title="operation.clientId ? operation.clientId.firstName : ''" header-tag='header' footer-tag='footer' :key='operation.id')
        template(v-slot:header='')
          h6.mb-0
            | {{ /*operation.passangerGroupID.passengerNumber*/ }} Pasajero -
        b-card-text
          | {{ operation.clientId ? operation.clientId.firstName : &quot;&quot; }}
          | {{
          | operation.clientId ? operation.clientId.lastName : &quot;&quot;
          | }}
        b-button(:to="{ name: 'Operation', params: { id: operation._id } }" v-on:click='getOperations' href='#' variant='primary') Ver operaci&oacute;n
        template(v-slot:footer='')
          em Detalles
</template>

<script>
//import axios from "axios";
import PxCard from "@/components/PxCard.vue";

import { mapState, mapGetters } from "vuex";

export default {
  name: "PxCards",
  components: {
    PxCard,
  },
  props: {
    title: String,
    filters: Array,
  },
  data() {
    return {
      //baseUrl: process.env.VUE_APP_BASE_URL,
      limit: 24,
      increment: 24,
    };
  },
  computed: {
    ...mapState(["operations", "loading", "errored"]),
    ...mapGetters(["operations", "loading", "errored"]),
    limitedOperations() {
      let sortedOperations = this.reverse(this.filteredOperations());
      return this.limit
        ? sortedOperations.slice(0, this.limit)
        : sortedOperations;
    },
  },
  /*watch: {
    // call again the method if the route changes
    $route: "fetchData",
  },*/
  /*async*/
  mounted() {
    //try {
    /*await*/
    //this.$store.dispatch("loadItems");
    //this.$store.dispatch("getOperations");
    //console.log(this.$store.getters.operations); // null
    //} catch (error) {
    //console.log(error);
    //this.errored = true;
    //} finally {
    //this.loading = false;
    //}
    /*this.$store.dispatch("loadItems");
    this.operations = this.$store.operations;*/
    /*this.loading = this.$store.loading;
    this.errored = this.$store.errored;*/
  },
  /*async mounted() {
    try {
      let response = await axios.get(this.baseUrl + "test.json");
      this.operations = response.data.operations;
      for (let i = 0; i < 4; i++) {
        this.operations[i + 1] = this.operations[0];
      }
    } catch (error) {
      console.log(error);
      this.errored = true;
    } finally {
      this.loading = false;
    }
  },
  created() {
    // Fetch Data
    /*this.fetchData((data) => {
      this.data = data;
      console.log(this.data);
    });*/
  /*this.fetchData();*/
  //},
  methods: {
    getOperations() {
      this.$store.commit("getOperations", this.operations);
      console.log(this.$store.state.operations);
    },
    reverse: (value) => {
      console.log(value);
      return value.slice().reverse();
    },
    filteredOperations() {
      let res = [];
      console.log("filters", this.filters);
      if (this.filters && this.operations) {
        //if (this.filters[0].value) {
        /*this.filters.find((filter) => {
          if (filter.filter == "date") {
            res = [
              this.operations.find((operation) => {
                return filter.value > operation.createdAt;
              }),
            ];
          }
        });*/
        res = this.operations;
        //res = [this.operations[0], this.operations[1]];
        /*} else {
          res = this.operations;
        }*/
      } else {
        res = this.operations;
      }
      return res;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

@media (min-width: 576px) {
  .card-columns {
    column-count: 2;
  }
}
</style>
